<hr />
<h2 class="mb-4">Purchase Order (Optional) </h2>

<h6 class="mb-4 ms-4 payment-blurb">
  This PO Number will appear on the receipt for this payment.   The PO Number on the individual orders will not be updated.
</h6>

<ng-container [formGroup]="form">
  <div class="row">
      <div class="col-4">
          <label for="poNumber">Purchase Order Number</label>
          <input appScrText placeholder="Purchase Order Number" id="poNumber" [formControlName]="'poNumber'" #poNumber
              maxlength="{{MaxLen.PurchaseOrderNumber}}" />
      </div>
  </div>

</ng-container>

